@if (dataSource.data.length === 0 && hpRetrieved) {
  <app-content-card cardTitle="Mijn Handelingsperspectieven">
    
    Er zijn geen handelingsperspectieven toegewezen aan dit account. Als u een Handelingsperspectief heeft aangevraagd moet deze eerst worden goedgekeurd. Wanneer dit is gebeurd, wordt u op de hoogte gesteld.
  </app-content-card>
}
@if (dataSource.data.length > 0) {
  <app-content-card cardTitle="Mijn handelingsperspectieven">
    <div class="container">
      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="location">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Locatie </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.location}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="locationId">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Locatie code </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.locationId}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="initiator">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Initiatiefnemer </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.initiator.name}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="motivation">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Motivatie </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.motivation}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Datum van aanmaken </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.createdAt | date:'d MMMM YYYY':'nl'}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" />
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowClicked(row)" class="clickable-row" />
      </mat-table>
    </div>
  </app-content-card>
}
